import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import FormContainer from '../common/FormContainer';
import LoginLink from '../common/LoginLink';
import { useTranslation } from 'react-i18next';

function SuccessMessage() {
  const { t } = useTranslation();
  return (
    <FormContainer>
      <Paper square sx={{ p: 3, width: 425 }}>
        <Typography variant="h5" gutterBottom>
          {t('auth.resetPassword.success.title')}
        </Typography>
        <Typography variant="body2" gutterBottom component="div">
          {t('auth.resetPassword.success.message')}
        </Typography>
      </Paper>
      <LoginLink/>
    </FormContainer>
  );
}

export default SuccessMessage;
